"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productSkuPatternErrorMessage = exports.productSkuPattern = void 0;
exports.productSkuPattern = /^[A-Z0-9-]+$/;
exports.productSkuPatternErrorMessage = 'Allowed only uppercase letters, symbol "-" and numbers.';
//# sourceMappingURL=productSkuPattern.js.map